import jaUI from '@linktivity/link-ui/lang/ja';
import country from '@link/share/i18n/country/ja';

import japanPrefectures from '@link/share/i18n/japanPrefectures/ja';
import {
  NotificationType,
  PaymentType,
  PaymentPeriod,
  BookingType,
  IssuedStatus,
  CancelReason,
  ConfirmationType,
  DiscrepancyType,
  DiscrepancyReason,
  DiscrepancyStatus,
  DiscrepancyWaitingStatus,
  DiscrepancyInitiator,
  NotificationMethod,
  WalletOrderStatus,
  TransactionTypeMap
} from '@link/share/services/const';

export default {
  ...jaUI,
  country,
  japanPrefectures,
  common: {
    account: 'アカウント',
    signOut: 'サインアウト',
    status: 'ステータス',
    action: '操作',
    parenthesis: '({{text}})',
    detail: '詳細',
    edit: '編集',
    add: '追加',
    save: '保存',
    or: 'または',
    delete: '削除',
    formTitle: '{{id}}（{{title}}）',
    withSpace: '{{val1}} {{val2}}',
    withDashSeparated: '{{val1}} - {{val2}}',
    withSlashSeparated: '{{val1}} × {{val2}}',
    withCommaSeparated: '{{val1}} / {{val2}}',
    slash: '/',
    confirm: '確定',
    editConfirm: '編集内容の確認',
    ON: 'オン',
    OFF: 'オフ',
    cancel: 'キャンセル',
    confirmDelete: '{{name}}を削除してもよろしいですか？',
    yes: 'はい',
    no: 'いいえ',
    close: '閉じる',
    has: 'あり',
    hasNot: 'なし',
    verify: '確認',
    register: '登録',
    continueEditing: '編集を続ける',
    leaveCurrentPage: 'このページを離れる',
    leaveCurrentPageConfirm: '{{name}}はまだ編集中です',
    separator: '、',
    pdf: 'PDF',
    mobile: 'スマホ',
    rangeSymbol: '~',
    pc: 'PC',
    grossPrice: '販売価格',
    netPrice: '卸価格',
    sender: '送信者',
    approver: '承認者',
    discrepancy: '差額調整内容',
    adjustmentAmount: '調整金額',
    commission: 'コミッション',
    cancelFee: 'キャンセル料',
    refundAmount: '返金金額',
    arrow: '→',
    colon: '：',
    empty: 'データなし',
    viewDetail: '詳細を見る',
    voucher: 'バウチャー',
    printableVoucher: '印刷用',
    forDisplayVoucher: '表示用',
    supplier: '催行会社',
    agent: '旅行代理店',
    complete: '完了',
    denied: '拒否',
    downloadDetails: '明細をダウンロード',
    total: '検索結果・{{total}} 件',
    infoSent: '情報は{{target}}へ送信されました。',
    currency: '通貨',
    zip: 'ZIP',
    excel: 'CSV',
    download: 'ダウンロード',
    manual: 'マニュアル'
  },
  views: {
    contractsList: {
      title: '販売権限設定状況',
      supplier: '催行会社（ID）',
      agent: '旅行代理店（ID）',
      systemChargePercent: '現在のシステム料金（%）',
      supplierCountry: '催行会社（国・地域）',
      agentCountry: '旅行代理店（国・地域）'
    },
    contractDetail: {
      addTitle: '契約を追加',
      editTitle: '契約を編集',
      title: '契約詳細',
      form: {
        supplier: '催行会社',
        agent: '旅行代理店',
        status: 'ステータス',
        systemChargePercent: '現在のシステム料金（%）'
      }
    },
    suppliersList: {
      supplierCustomId: '催行会社ID'
    },
    suppliersDetail: {
      title: '会社情報',
      supplierCustomId: '催行会社ID',
      originalName: '催行会社名',
      englishName: '催行会社（英語）',
      status: 'ステータス',
      mainLanguage: '利用言語',
      salesAccounts: '営業担当',
      webUrl: 'Official site URL',
      countryCode: '国・地域',
      categories: 'カテゴリ',
      registrationCode: '適格請求書発行事業者登録番号',
      logoUrl: 'ロゴ',
      privacyPolicyType: 'プライバシーポリシー処理',
      currency: '利用通貨',
      transferFeePayer: '振込手数料負担',
      billingMethod: '精算方法',
      systemFeeRefundPolicyCustomer: 'システム利用料返金（お客様キャンセル）',
      systemFeeRefundPolicySupplier: 'システム利用料返金（催行会社キャンセル）',
      systemFeeRefundPolicyInvalid: 'システム利用料返金（無効化処理）'
    },
    suppliersAccount: {
      title: 'アカウント管理',
      role: '権限',
      supplierCustomId: '催行会社',
      loginId: 'メールアドレス',
      username: 'ユーザー名',
      supportLanguages: '利用言語'
    },
    suppliersAccountDetail: {
      addTitle: 'アカウント追加',
      editTitle: 'アカウント編集',
      supplierId: '催行会社',
      loginId: 'メールアドレス（ログインID）',
      password: 'パスワード',
      supportLanguages: '利用言語',
      role: '権限',
      notificationType: '通知タイプ',
      username: 'ユーザー名',
      phoneNumber: '電話番号',
      personInCharge: '担当者名',
      department: '部署・役職',
      receiveNotifications: '通知を受け取る',
      notificationMethod: '通知の受け取り方法',
      requireMfa: '2段階認証'
    },
    newAgent: {
      otaCustomId: '旅行代理店ID',
      title: '旅行代理店追加',
      originalName: '旅行代理店名',
      englishName: '旅行代理店名（EN）',
      contractType: '署名された契約',
      mainLanguage: '主要言語',
      salesAccounts: '営業担当',
      webUrl: 'Official site URL',
      country: '国・地域',
      currency: '利用通貨',
      logoUrl: 'ロゴ',
      paymentType: '支払方法',
      paymentPeriod: '精算サイクル'
    },
    agentAccountList: {
      role: '権限',
      org: '所属グループ',
      loginId: 'ユーザーID',
      username: 'ユーザー名',
      supportLanguages: '利用言語'
    },
    newAgentAccount: {
      title: '新規アカウント追加',
      otaId: '旅行代理店',
      otaOrgId: '所属グループ',
      loginId: 'メールアドレス（ログインID）',
      password: 'パスワード',
      role: '権限',
      supportLanguages: '利用言語',
      notificationType: '通知タイプ',
      username: 'ユーザー名',
      phoneNumber: '電話番号',
      personInCharge: '担当者名',
      department: '部署・役職',
      requireMfa: '2段階認証'
    },
    orgList: {
      country: '国・地域',
      parentOtaOrg: '親グループ',
      otaOrgName: 'グループ名'
    },
    newOrg: {
      title: 'グループ追加',
      otaOrgCustomId: 'グループID',
      otaOrgName: 'グループ名',
      otaId: '旅行代理店',
      otaOrgId: 'グループID',
      parentOtaOrgId: '親グループ',
      countryCode: '国・地域',
      logoUrl: 'ロゴ',
      activityIdWhitelist: '商品販売設定'
    },
    login: {
      title: 'Welcome to GDS',
      email: 'メールアドレス',
      password: 'パスワード',
      button: 'ログイン',
      success: 'ログインしました',
      link: 'パスワードをお忘れの方はこちら',
      resettitle: 'パスワード再設定',
      reset: 'パスワード再設定メールを送信',
      send: 'パスワード再設定用のURLを{{email}}に送信しました。メールをご確認のうえ、パスワードを再設定してください。',
      resetError:
        'メールの送信に失敗しました。しばらくしてから再試行してください。',
      googleLogin: 'Googleアカウントでログイン',
      register: '新規登録・お問い合わせはこちら',
      privacy: 'プライバシーポリシー',
      ipNotAllowed: 'ネットワークエラーが発生しました。もう一度お試しください。'
    },
    enrollOTP: {
      title: '二段階認証の設定',
      description:
        'アカウントのセキュリティを強化するため、認証アプリでQRコードをスキャンしてください',
      step1: '1. Google Authenticatorをスマートフォンにインストール',
      appStore: 'App Store (iOS)',
      googlePlay: 'Google Play (Android)',
      step2: '2. QRコードをスキャン',
      step3: '3. 表示された6桁のコードを入力して完了',
      qrLabel: 'QRコード',
      codeLabel: '認証アプリの6桁コード',
      submit: '確認して有効化',
      enrollError: '認証コードが正しくありません。もう一度お試しください'
    },
    verifyOTP: {
      title: '二段階認証',
      code: '認証コード',
      verify: '確認',
      verifyError: '認証コードが正しくありません。もう一度お試しください'
    },
    changePassword: {
      title: 'パスワード変更',
      oldPassword: '現在の【パスワード】',
      newPassword: '新しい【パスワード】'
    },
    booking: {
      bookingCustomId: '予約番号',
      status: 'ステータス',
      purchasedDate: '申込日',
      participationDate: '参加日',
      freeSale: 'フリーセール',
      participationTime: '開始時間',
      activityTitleSupplierLang: '商品',
      planTitle: 'プラン',
      orderCount: '数量',
      firstName: '参加者名',
      participantResidentRegion: '参加者居住国・地域',
      participantEmailAddress: '参加者メール',
      destinationEmail: '連絡先情報',
      agentReservationNote: '代理店予約番号',
      agentBookingIdRemark: '旅行代理店予約番号（備考）',
      agentReservationSpecialNote: '旅行代理店予約特記事項',
      supplierBookingId: '催行会社予約番号',
      bookingDetail: '予約詳細',
      bookingNumber: '予約番号',
      parentBookingNumber: '子商品予約番号',
      bookingType: '購入区分',
      applicationDate: '申込日',
      bookingStatus: '予約ステータス',
      cancelledBySupplier: '催行会社から',
      issuedStatus: '利用状況',
      bookerName: '予約代表者氏名',
      product: '商品・プラン',
      productVoucherLang: '商品・プラン（予約言語）',
      voucherExpiration: 'バウチャー有効期限',
      paymentInfo: '支払情報',
      salePrice: '販売価格',
      commission: 'コミッション',
      netPrice: '卸価格',
      free: 'フリーセール',
      individual: '個別',
      download: 'ダウンロード',
      exchangeUrl: '引換用URL',
      openUrl: 'URLを開く',
      discrepancies: '差額調整',
      cancelBooking: '予約をキャンセル',
      invalidBookingBtn: '予約を無効化',
      invalidBooking: 'この予約を無効化しますか？',
      invalidBookingConfirmP1: '選択した予約を無効化しますか？',
      invalidBookingConfirmP2:
        'この操作は取り消せません。続行する前に内容をご確認ください。',
      invalidBookingConfirmP3:
        '無効化後の精算書への反映方法は、次のステップで選択できます。',
      invalidBookingConfirmText: '無効化する',
      invalidBookingConfirmProcessing:
        '現在処理中の予約です。それでも無効化しますか？',
      invalidBookingSecondTitle: '精算書への反映方法を選択',
      invalidBookingOpt1Title:
        '1.予約確定日が属する月（または週）の精算書へ反映',
      invalidBookingOpt1P1:
        '本予約の予約確定日が属する月（または週）の精算書へ、全額返金扱いとして反映させます。',
      invalidBookingOpt1P2:
        '無効化操作日時が、本予約の予約確定日が属する月（または週）の精算締め日を過ぎており、精算書が発行済みの場合、当該月（または週）の精算書が再発行されます。',
      invalidBookingOpt1P3:
        '無効化処理完了後は、必ず最新バージョンの精算書を再度ダウンロードしご確認ください。',
      invalidBookingOpt1P4: 'また、本予約情報は、',
      invalidBookingOpt1P5:
        '無効化操作日時が属する月（または週）の精算書には記載されません。',
      invalidBookingOpt2Title:
        '2.無効化操作日時が属する月（または週）の精算書へ反映',
      invalidBookingOpt2P1:
        '本予約の無効化操作日時が属する月（または週）の精算書へ、全額返金扱いとして反映させます。',
      invalidBookingOpt2P2:
        '無効化操作日時が、本予約の予約確定日が属する月（または週）の精算締め日を過ぎており、精算書が発行済みの場合でも、精算書の再発行は行われません。',
      cancelFeeAndRefundAmount: 'キャンセル料と返金額',
      currentDateTime: '現在の日付・時刻',
      amount: '金額',
      paidAmount: '支払金額',
      cancelFee: 'キャンセル料',
      refundAmount: '返金額',
      confirmedBy: '確認者名',
      performCancel: 'キャンセルを行う',
      cancelResult: 'キャンセルを完了しました。',
      cancelSucceed: 'キャンセルが完了しました',
      cancelPending:
        'キャンセルを処理中です。サプライヤーの返信をお待ちください。',
      unitAdditionalLabel: '{{unitTitle}}{{unitIndex}}の追加予約情報',
      cancelReason: 'キャンセル理由',
      cancelComment: 'キャンセルコメント',
      denyReason: '拒否理由',
      name: '{{firstName}} {{lastName}}',
      otaName: '販売者名',
      endUserRefundAmount: 'エンドユーザー返金額',
      paymentRefundAmount: '決済返金金額',
      cancelFeeFromTravelerToAgent: 'キャンセル料（旅行者から代理店へ）',
      cancelFeeFromAgentToLink: 'キャンセル料（旅行代理店からLINKTIVITYへ）',
      finalSettlementToLink: '最終精算金額（LINKTIVITYへ）',
      paymentRefundAmountOta: '決済返金金額（旅行代理店）',
      cancelFeeFromLinkToSupplier: 'キャンセル料（LINKTIVITYから催行会社へ）',
      systemCharge: 'システムチャージ',
      finalSettlementFromLink: '最終精算金額（LINKTIVITYから）',
      linkCancelFee: 'キャンセル料（LINKTIVITY回収分）',
      linkRevenue: 'LINKTIVITY収益'
    },
    discrepancies: {
      title: '差額調整リクエスト{{type}}',
      finished: '送信済み',
      return: '予約詳細へ戻る',
      send: '送信',
      receive: '受信',
      discrepancy: '差額調整',
      discrepancyType: '調整内容',
      reasonDescription: '詳細',
      reason: '理由',
      priceAdjust: '調整金額(差額)',
      grossAdjustmentAmount: '販売価格',
      netAdjustmentAmount: '卸価格',
      addItem: '項目を追加',
      bookingInfo: '予約情報',
      adjustmentItem: '調整項目',
      verifier: '確認者名',
      applicant: '申請者',
      enterName: 'お名前を入力してください',
      apply: '申請する',
      adjustmentAmount: '調整金額',
      originalGrossAmount: '元の販売価格',
      originalNetAmount: '元の卸価格',
      adjustedGrossAmount: '調整後販売価格',
      adjustedNetAmount: '調整後卸価格',
      requiredAmount: '金額を入力してください',
      applySuccessTitle: '差額調整リクエストを送信しました',
      approveSuccessTitle: '差額調整リクエストを承認しました',
      denySuccessTitle: '差額調整リクエストを拒否しました',
      successMsg: '承認された調整金額は、直近の支払月に反映されます。',
      alert:
        '確定すると、この差額調整リクエストが承認依頼として{{target}}に通知されます。',
      waitingTip:
        '以下の調整項目を{{target}}へ送信しました。現在、{{target}}の承認待ちです。',
      reviewTip: 'この差額調整項目を承認しますか？',
      approve: '承認する',
      deny: '拒否する'
    },
    bookingList: {
      title: '予約管理',
      filter: {
        bookingCustomId: '予約番号',
        activityTitle: '商品名',
        planTitle: 'プラン名',
        status: 'ステータス',
        participantName: '予約代表者氏名',
        participantEmail: '予約代表者メールアドレス',
        purchasedAtStart: '申込日',
        participateDateStart: '参加日（開催地の現地時間基準）',
        agentReservationNo: '旅行代理店予約番号',
        supplierBookingId: '催行会社予約番号'
      },
      participantResidentRegion: '国・地域'
    },
    bulkBookingList: {
      title: '予約管理',
      reservationNumber: '予約番号',
      status: 'ステータス',
      submitDate: '提出日',
      product: '商品',
      plan: 'プラン',
      agent: '旅行代理店'
    },
    discrepancyList: {
      title: '差額調整',
      purchaseDate: '購入日',
      participationDate: '参加日',
      keyword: 'キーワード',
      activity: '商品',
      plan: 'プラン',
      reservationNumber: '予約番号',
      transactionType: '取引の種類',
      adjustmentStatus: '調整ステータス',
      salesPrice: '販売価格',
      wholesalePrice: '卸価格',
      sender: '送信者',
      senderFormat: '{{senderName}} ({{initiator}})'
    },
    notificationInbox: {
      title: '通知一覧',
      all: '全部 ({{count}})',
      summary: '合計{{total}}件・未読{{unread}}件',
      empty: '通知はありません',
      detailPlaceholder: '左側の通知を選択し、通知詳細を確認してください。',
      detailLoadError: '通知詳細の取得に失敗しました'
    },
    invoiceChange: {
      title: '金額調整',
      adjustmentDate: '調整日',
      adjustedBy: '調整者',
      invoiceAmount: '請求金額',
      adjustmentAmount: '調整金額',
      paymentAmount: '支払金額',
      adjustmentReason: '調整理由',
      submit: '確認',
      addFile: 'ファイルを添付する',
      historyTitle: '金額調整履歴',
      finalAmount: '調整後の支払金額'
    }
  },
  const: {
    cancelErrorCode: {
      BOOKING_NOT_FOUND: '予約が見つかりません',
      BOOKING_ALREADY_CANCELLED: 'すでにキャンセルされています',
      CANCEL_DEADLINE_PASSED: 'キャンセル期限を過ぎています',
      BOOKING_ALREADY_ISSUED: 'この予約は発券済みのため、キャンセルできません',
      BOOKING_STATUS_NOT_CANCELLABLE:
        'この予約は現在の状態ではキャンセルできません',
      BOOKING_INVALIDATION_IN_PROGRESS:
        'この予約は無効化処理中のため、キャンセルできません',
      BOOKING_DECLINE_INSTEAD_OF_CANCEL:
        'この予約はキャンセルではなく拒否が必要です',
      BOOKING_NOT_CANCELLABLE: 'この予約はキャンセルできません',
      CANCEL_NOT_STARTED: 'キャンセル手続きが開始されていません',
      CANCEL_REFUND_CHANGED: 'キャンセル料・返金額が変更されました',
      BOOKING_ADAPTER_BOOKING_NOT_CANCELLABLE:
        '催行会社によりキャンセルが拒否されました',
      BOOKING_ADAPTER_EXTERNAL_FAILED:
        '催行会社によりキャンセルが拒否されました',
      BOOKING_ADAPTER_EXTERNAL_PENDING:
        '催行会社の確認待ちです。しばらくしてから再度お試しください',
      RETRYABLE: 'しばらくしてから再度お試しください',
      UNKNOWN: 'この予約はキャンセルできません'
    },
    cancelDeadline: 'キャンセル期限：{{deadline}}',
    language: {
      JAPANESE: '日本語',
      ENGLISH: '英語',
      CHINESE: '中国語（簡体）',
      CHINESE_T: '中国語（繁体字）',
      KOREAN: '韓国語'
    },
    partnerCategory: {
      RAILWAY: '鉄道',
      BUS: 'バス',
      FERRIES: 'フェリー',
      RENTAL_CAR: 'レンタカー',
      SIGHTSEEING_SPOT: '観光スポット',
      FOOD: 'レストラン',
      EXPERIENCE: '体験',
      ACCOMMODATION: 'ホテル',
      TOUR: 'ツアー',
      ACTIVITY: 'アクティビティ',
      CHARTER: 'チャーター',
      LINKTIVITY: 'LINKTIVITY',
      OTHERS: 'その他'
    },
    privacyPolicyType: {
      EMAIL_NOT_SHOW: 'お客様のEメールを非表示',
      NAME_NOT_SHOW: 'お客様氏名を非表示',
      REGISTERED_CODE_NOT_SHOW: '予約番号を非表示',
      OTA_BOOKING_ID_NOT_SHOW: '旅行代理店予約番号を非表示',
      SUPPLIER_BOOKING_ID_NOT_SHOW: '催行会社予約番号を非表示'
    },
    transferFeePayer: {
      LINK: 'LINKTIVITY',
      SUPPLIER: '貴社'
    },
    billingMethod: {
      PURCHASE_DATE: '購入日基準',
      USAGE_DATE: '参加日(利用日)基準'
    },
    systemFeeRefundPolicy: {
      NO_REFUND: '返金しない',
      ALL_REFUND: '全額返金'
    },
    role: {
      ADMIN: '管理者',
      VIEWER: '閲覧のみ',
      EDITOR: '予約・商品情報編集',
      OPERATOR: 'オペレーター'
    },
    contractType: {
      equivalent: 'TERM_OF_SERVICE_V20181101同等',
      nonEquivalent: 'TERM_OF_SERVICE_V20181101非同等'
    },
    checklistType: {
      RESTRICTION: '参加制限',
      REQUIRED_ITEM_TO_BRING_AND_ATTIRE: '参加時必要な服装・持ち物',
      REQUIRED_OTHER: '参加時に必須のその他のこと',
      REQUIRED_ADDITIONAL_NOTE: '備考・その他',
      NICE_TO_HAVE_ITEM_TO_BRING_AND_ATTIRE: 'おすすめの服装や持ち物',
      NICE_TO_HAVE_OTHER: 'その他のおすすめ',
      INCLUDED: '含まれるもの'
    },
    notificationType: {
      [NotificationType.NoNotification]: '通知なし',
      [NotificationType.ActivityOperation]: '商品関連',
      [NotificationType.BookOperation]: '予約関連',
      [NotificationType.FinanceOperation]: '精算・財務関連',
      [NotificationType.SystemOperation]: 'LINKからのお知らせ'
    },
    inboxCategory: {
      [NotificationType.ActivityOperation]: '商品関連',
      [NotificationType.BookOperation]: '予約関連',
      [NotificationType.FinanceOperation]: '精算・財務関連',
      [NotificationType.SystemOperation]: 'LINKからのお知らせ',
      [NotificationType.UndefinedNotification]: 'その他',
      [NotificationType.NoNotification]: 'なし'
    },
    notificationMethod: {
      [NotificationMethod.UndefinedMethod]: '未定義',
      [NotificationMethod.Email]: 'メール',
      [NotificationMethod.InternalMessage]: 'サイト内通知'
    },
    paymentType: {
      [PaymentType.PostBankTransfer]: '後払い（銀行振込）',
      [PaymentType.PreLinkpay]: 'オンライン決済（前払い）',
      [PaymentType.PostLinkpay]: '後払い（LinkPay）',
      [PaymentType.PreCharge]: '銀行振込（前払い）'
    },
    paymentPeriod: {
      [PaymentPeriod.Weekly]: '週単位',
      [PaymentPeriod.Monthly]: '月単位',
      [PaymentPeriod.HalfMonthly]: '隔週単位'
    },
    attachmentType: {
      PDF: 'PDF',
      IMAGE: 'イメージ'
    },
    bookingField: {
      PARTICIPANT_EMAIL_ADDRESS: '参加者メール',
      HOTEL_NAME: '宿泊施設名',
      HOTEL_ADDRESS: '宿泊施設住所',
      HOTEL_RESERVATION_LAST_NAME: '宿泊代表者氏名（姓）',
      HOTEL_RESERVATION_FIRST_NAME: '宿泊代表者氏名（名）',
      HOTEL_TEL: '宿泊施設電話番号',
      ARRIVAL_DATE: '現地到着日',
      ARRIVAL_TIME: '到着時刻',
      ARRIVAL_FLIGHT_NUMBER: 'フライト到着便名',
      DEPARTURE_DATE: '出発日',
      DEPARTURE_TIME: '出発時刻',
      DEPARTURE_FLIGHT_NUMBER: 'フライト出発便名',
      DESTINATION_EMAIL: '現地連絡先（メールアドレス）',
      DESTINATION_TEL: '現地連絡先（電話番号）',
      PARTICIPANT_RESIDENT_REGION: '参加者居住国・地域',
      PARTICIPANT_LANGUAGE: '参加者使用言語'
    },
    extendedBookingField: {
      PASSENGERS_QUANTITY: '乗車人数',
      PREFERRED_START_TIME: '希望開始時刻',
      PREFERRED_PICK_UP_LOCATION: 'お迎え・乗車場所',
      PREFERRED_DROP_OFF_LOCATION: 'お送り・降車場所',
      PARTICIPANTS_QUANTITY: '参加人数',
      LUGGAGE_QUANTITY: 'スーツケース数（合計）',
      CHILDREN_WITHOUT_SEAT_QUANTITY: '座席不要の幼児',
      CHILD_SEAT_QUANTITY_PAID: 'チャイルドシート利用（現地払い）',
      CHILD_SEAT_QUANTITY_FREE: 'チャイルドシート利用（無料）',
      PREFERRED_GUIDE_LANGUAGE_CODE: 'ガイド言語の希望',
      PREFERRED_DRIVER_LANGUAGE_CODE: 'ドライバー言語の希望'
    },
    extendedParticipantField: {
      PASSPORT_FIRST_NAME: '参加者名（パスポート記載のローマ字名）',
      PASSPORT_LAST_NAME: '参加者姓（パスポート記載のローマ字姓）',
      PASSPORT_NATIONALITY: '国籍',
      PASSPORT_NUMBER: 'パスポート番号',
      DATE_OF_BIRTH: '生年月日',
      AGE: '年齢',
      GENDER: '性別',
      EYESIGHT: '視力',
      WEIGHT_KG: '体重（kg）',
      HEIGHT_CM: '身長（cm）',
      SHOE_SIZE_CM: '靴のサイズ（cm）',
      CLOTHES_SIZE: '服のサイズ',
      VEGETARIAN_MEALS: 'ベジタリアン対応希望',
      DIVING_EXPERIENCE_TIMES: 'ダイビング経験本数（本）',
      RENTAL_EQUIPMENTS_FREE: '器材レンタル希望（無料）',
      RENTAL_EQUIPMENTS_PAY_LOCALLY: '器材レンタル希望（現地払い）'
    },
    bookingStatus: {
      REQUEST_PENDING: 'リクエスト中',
      REQUEST_REJECTED: '却下',
      CONFIRMED: '確定済み',
      CANCELLED_BY_TRAVELER: 'キャンセル（お客様）',
      CANCELLED_BY_SUPPLIER: 'キャンセル（催行会社）',
      INVALID: '無効化',
      CANCEL_FAILED: 'キャンセル失敗',
      CANCEL_PENDING: 'キャンセル保留中'
    },
    bulkBookingStatus: {
      SUBMITTED: '提出済',
      PAID: '送金済',
      ACCEPTED: '承認完了',
      QUEUED: '発行待機中',
      ISSUED: '発行済',
      PENDING: '保留中'
    },
    bulkBookingAction: {
      SUBMIT: '提出',
      PAY: '送金',
      ACCEPT: '承認',
      PEND: '保留',
      ISSUE: '発券',
      FINISH: '完了'
    },
    confirmationType: {
      [ConfirmationType.FreeSale]: '参加日指定（フリーセル）',
      [ConfirmationType.FreeSaleOpenDate]: '参加日指定なし（フリーセル）',
      [ConfirmationType.Inventory]: '参加日指定（リアルタイム）',
      [ConfirmationType.Request]: '参加日指定あり（リクエスト）'
    },
    // use for bookingDetail page
    bookingConfirmationType: {
      [ConfirmationType.FreeSale]: 'フリーセル',
      [ConfirmationType.FreeSaleOpenDate]: 'フリーセル',
      [ConfirmationType.Inventory]: 'リアルタイム',
      [ConfirmationType.Request]: 'リクエスト'
    },
    walletOrderStatus: {
      [WalletOrderStatus.StatusPending]: '未払',
      [WalletOrderStatus.StatusPaying]: 'チャージ未完了',
      [WalletOrderStatus.StatusPaid]: '送金完了',
      [WalletOrderStatus.StatusRejected]: '拒否済',
      [WalletOrderStatus.StatusCancelled]: 'キャンセル済',
      [WalletOrderStatus.StatusConfirmed]: 'チャージ完了',
      [WalletOrderStatus.StatusRefunded]: '返金済'
    },
    transactionTypeMap: {
      [TransactionTypeMap.TransactionTypeCancelRefund]: 'キャンセル済',
      [TransactionTypeMap.TransactionTypePurchase]: '確定済み',
      [TransactionTypeMap.TransactionTypeDiscrepancy]: '差額調整済み',
      [TransactionTypeMap.TransactionTypeInvalid]: '無効化済み'
    },
    discrepancyStatus: {
      [DiscrepancyStatus.Waiting]: '承認待ち',
      [DiscrepancyStatus.Approved]: '調整完了',
      [DiscrepancyStatus.Rejected]: '却下'
    },
    discrepancyWaitingStatus: {
      [DiscrepancyWaitingStatus.Deliver]: '承認待ち',
      [DiscrepancyWaitingStatus.Receive]: '承認対応待ち'
    },
    discrepancyInitiator: {
      [DiscrepancyInitiator.Ota]: '代理旅行店',
      [DiscrepancyInitiator.Supplier]: '催行会社'
    },
    discrepancyType: {
      [DiscrepancyType.Refund]: '返金',
      [DiscrepancyType.AdditionalCharge]: '追加請求'
    },
    discrepancyReason: {
      [DiscrepancyReason.AdditionalServices]: '商品追加料金',
      [DiscrepancyReason.MissedServices]: '未提供による返金',
      [DiscrepancyReason.CustomerComplaint]: 'クレームによる返金',
      [DiscrepancyReason.DoubleCharge]: '二重請求',
      [DiscrepancyReason.FeeForBookingChange]: '変更手数料',
      [DiscrepancyReason.PartialCancel]: '一部取消',
      [DiscrepancyReason.SelfAdjustment]: '個別調整',
      [DiscrepancyReason.Other]: 'その他'
    },
    bookingType: {
      [BookingType.Bulk]: '一括処理',
      [BookingType.Single]: '個別処理'
    },
    issuedStatus: {
      [IssuedStatus.Issued]: '使用済み',
      [IssuedStatus.NotIssued]: '未使用',
      [IssuedStatus.Partial]: '一部使用',
      [IssuedStatus.Disable]: '無効'
    },
    cancelReason: {
      [CancelReason.BadWeather]: '悪天候',
      [CancelReason.BookedByMistake]: '誤って予約したため',
      [CancelReason.DoubleBooking]: '重複予約のため',
      [CancelReason.FlightIssues]: 'フライトのキャンセル・遅延・変更のため',
      [CancelReason.FoundCheaperRate]: 'より安い価格を見つけた',
      [CancelReason.Other]: 'その他',
      [CancelReason.ParticipantMinimumNotMet]: '最少催行人数未達',
      [CancelReason.ParticipantOrDateChange]: '予約日または人数の変更',
      [CancelReason.PrivateBuyout]: '団体貸切・満席',
      [CancelReason.SameSupplierActivityChange]: '同一催行会社の別商品へ変更',
      [CancelReason.SeparateSupplierActivityChange]:
        'ほかの催行会社の商品へ変更',
      [CancelReason.Sickness]: '体調不良',
      [CancelReason.OtaCancelWithoutReason]: 'OTAによる理由不明のキャンセル',
      [CancelReason.TechnicalDifficulties]: '機器故障または予期せぬトラブル'
    },
    category: {
      RAILWAY_TICKET: '鉄道乗車券',
      AIRPORT_TRANSPORTATION: '空港アクセス',
      SHINKANSEN: '新幹線',
      EXPRESS_BUS: '高速バス',
      BUS_TOUR: 'バスツアー',
      CRUISES: 'フェリー・クルーズ',
      RENTAL_CAR: 'レンタカー',
      CHARTER: 'チャーター',
      ATTRACTION: '施設（入場券）',
      THEME_PARK: 'テーマパーク',
      MUSEUM_GALLERY: '博物館・美術館',
      AQUARIUM_ZOO: '水族館・動物園',
      TEMPLES_SHINES: '寺社仏閣',
      TOWER_BUILDING: '展望台・タワー',
      JAPANESE_RESTAURANT: '和食レストラン',
      WESTERN_RESTAURANT: '洋食レストラン',
      CHINESE_RESTAURANT: '中華レストラン',
      OTHER_RESTAURANT: 'レストラン（その他）',
      DESSERT_BEVERAGE: 'デザート・ドリンク',
      SIGHTSEEING_TOUR: '観光ツアー',
      MARINE_SPORTS: 'マリンスポーツ',
      OUTDOOR_ACTIVITIES: 'アウトドアアクティビティ',
      ONSEN: '温泉',
      SPA_MASSAGE: 'スパ・マッサージ',
      JAPANESE_CULTURAL_EXPERIENCE: '日本文化体験',
      JAPANESE_CRAFT_EXPERIENCE: '日本工芸体験',
      JAPANESE_COOKING_EXPERIENCE: '和食作り体験',
      OTHER_EXPERIENCE: 'その他の体験',
      HOTEL: 'ホテル',
      RYOKAN: '旅館',
      VACATION_RENTAL: '民泊',
      BUNDLE: 'セット',
      PASS: 'パス',
      OTHERS: 'その他'
    },
    possibleIntervalShow: {
      DAY: '{{amount}}日間以内',
      MONTH: '{{amount}}ヶ月以内'
    },
    voucherExpirationFromPurchase: {
      DAY: '購入日から{{time}}日間',
      MONTH: '購入日から{{time}}ヶ月間',
      SAME_DAY: '購入日当日'
    },
    voucherExpirationFromActivity: {
      DAY: '参加日から{{time}}日間',
      MONTH: '参加日から{{time}}ヶ月間',
      SAME_DAY: '参加日当日'
    }
  },
  week: {
    SUNDAY: '日',
    MONDAY: '月',
    TUESDAY: '火',
    WEDNESDAY: '水',
    THURSDAY: '木',
    FRIDAY: '金',
    SATURDAY: '土'
  },
  bankInfo: {
    swiftCode: 'SWIFTコード',
    bankName: '銀行名',
    bankCode: '金融機関コード',
    bankBranchCode: '支店番号',
    bankBranchName: '支店名',
    bankAddress: '銀行住所',
    bankAccountNumber: '口座番号',
    accountHolderName: '口座名義'
  },
  validation: {
    required: '{{name}}は必須です',
    invalid: '有効な{{name}}を入力してください',
    password: '半角英数字と記号を組み合わせ、8文字以上で作成してください',
    imageType: '画像を選択してください',
    fileSize: '{{size}}MB以下のファイルを選択してください',
    range: '{{name}}は{{min}}～{{max}}の範囲で入力してください',
    greaterThan: '{{name}}は{{min}}より大きい値を入力してください',
    notEqual: '{{name}}に{{value}}は入力できません',
    integer: '{{name}}は整数で入力してください',
    requiredSelect: '選択してください',
    alphabet: '半角英字で入力してください（スペース可、数字不可）',
    otaCustomIdFormat:
      '英大文字・数字・アンダースコアで1〜16文字、先頭は英大文字または数字で入力してください',
    maxLength: '{{name}}は{{max}}文字以内で入力してください',
    personName: "{{name}}に数字・記号は入力できません（' - . は使用可）",
    telFormat: '数字・「+」・「-」のみ、8〜20文字で入力してください',
    flightNumber:
      '半角英数字3〜8文字で、英字と数字を組み合わせて入力してください',
    dateNotBefore: '{{name}}は{{min}}以降の日付を入力してください',
    dateNotAfter: '{{name}}は{{max}}以前の日付を入力してください',
    passportName:
      "パスポート記載のローマ字（半角英字、スペースと ' - . のみ）で入力してください",
    passportNumber: '半角英数字6〜12文字で入力してください',
    ageMismatch: '生年月日から計算した年齢（{{age}}歳）と一致しません'
  },
  messages: {
    newSuccess: '追加しました',
    updateSuccess: '更新しました',
    deleteSuccess: '削除しました',
    copySuccess: 'コピーしました',
    updateFailed: '更新できませんでした',
    dateMax3Months: '日付範囲は3か月以内で指定してください',
    downloadSuccess: 'ダウンロードが完了しました'
  },
  confirmDelete: {
    title: 'ご確認ください',
    prompt: '削除してもよろしいですか？'
  },
  autoLogout: {
    title: 'まもなく自動ログアウトされます',
    description1:
      'セキュリティのため、9時間操作がなかった場合は自動的にログアウトされます。',
    description2: 'ご利用を続ける場合は「続ける」をクリックしてください。',
    logout: '今すぐログアウト',
    continue: '続ける'
  },
  firebase: {
    'auth/invalid-credential': 'ログイン名またはパスワードが正しくありません。',
    'auth/email-already-in-use': 'このメールアドレスは既に登録されています。',
    'auth/too-many-requests':
      'ログイン試行の回数が上限を超えました。しばらくしてからもう一度お試しいただくか、パスワードをリセットしてください。'
  },
  wallet: {
    feeRate: '手数料率',
    fee: '手数料',
    deductAmount: '合計金額',
    proceedToPayment: '同意して支払に進む',
    invalidAmount: '正しい金額を入力してください'
  },
  transaction: {
    csvApplyDateTimezoneNote:
      '※ご注意：精算書明細CSVの申請日は、旅行代理店のローカル（ブラウザ）時間ではなく、催行会社が設定した商品タイムゾーンの時間が適用されます。'
  },
  activityDetail: {
    title: '商品詳細',
    planTitle: 'プラン詳細',
    faq: 'FAQ',
    location: '{{country}}',
    city: '・{{city}}',
    activity: {
      content: '商品内容',
      api: 'API Code',
      cancelPolicy: 'キャンセルポリシー',
      productId: '商品ID',
      operator: '催行会社',
      timezone: 'タイムゾーン',
      currency: '通貨',
      language: '掲載言語',
      category: 'カテゴリ',
      departure: '出発地',
      destination: '目的地',
      activityId: 'Activity Id',
      activityName: 'Activity Name',
      planId: 'Plan Id',
      planName: 'Plan Name',
      planStartTimeId: 'Plan Start Time Id',
      planStartTimeName: 'Plan Start Time Name',
      startTime: 'Start Time',
      planUnitItemsId: 'Plan Unit Items Id',
      planUnitName: 'Plan Unit Name'
    },
    plans: {
      description: '予約情報',
      notes: '注意事項',
      schedule: 'スケジュール',
      locations: '場所',
      additionalBookingInfo: '追加予約情報',
      startTime: '開始時間',
      noTimeLimit: '無制限',
      availableCount: '予約可能数',
      availableCountShow: '{{min}} ~ {{max}}',
      availablePeriod: '公開期間',
      availablePeriodShow:
        '{{startY}}-{{startM}}-{{startD}} ~ {{endY}}-{{endM}}-{{endD}}',
      possibleInterval: '予約可能期間',
      reservationDeadline: '予約受付期限',
      reservationDeadlineShow:
        '参加日の{{day}}日前の{{time}}までにご予約ください。',
      reservationDeadlineShowToday: '当日{{time}}までにご予約ください。',
      voucherExpiration: 'バウチャー有効期限',
      voucherExpirationAnnualCutOff:
        '年の増分基準日：{{annualFixedDate}}以前の購入分は当年相対固定日：{{annualCutOffDate}}までに失効し、年の増分基準日：{{annualFixedDate}}以降の購入分は翌年相対固定日：{{annualCutOffDate}}までに失効する',
      optionalBookingFields: '代表者情報（任意）',
      optionalExtendedBookingFields: 'その他情報（任意）',
      optionalParticipantFields: '利用者情報※参加者ごと（任意）',
      requiredBookingFields: '代表者情報（必須）',
      requiredExtendedBookingFields: 'その他情報（必須）',
      requiredParticipantFields: '利用者情報※参加者ごと（必須）',
      customFields: 'カスタマイズ予約情報',
      customFieldsShow: '{{title}} : {{des}}',
      meetingPlace: '集合場所',
      dismissalPlace: '解散場所',
      pickupPlace: 'ピックアップ場所',
      dropOffPlace: 'お送り場所'
    }
  }
};
